<template>
    <div>
        <el-tabs>
            <el-tab-pane label="话题列表">
                <div class="page-filter-box">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                            <el-select v-model="params.isRecommend" placeholder="请选择" size="small">
                                <el-option label="不限制推荐状态" :value="-1"></el-option>
                                <el-option label="仅看推荐的" :value="1"></el-option>
                                <el-option label="仅看非推荐的" :value="0"></el-option>
                            </el-select>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                            <el-select v-model="params.sortType" placeholder="请选择" size="small">
                                <el-option label="按内容数从多至少排序" :value="1"></el-option>
                                <el-option label="按内容数从少至多排序" :value="2"></el-option>
                                <el-option label="按围观人数从多至少排序" :value="3"></el-option>
                                <el-option label="按围观人数从少至多排序" :value="4"></el-option>
                                <el-option label="按排序序号从大至小排序" :value="5"></el-option>
                                <el-option label="按排序序号从小至大排序" :value="6"></el-option>
                            </el-select>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                            <el-input v-model="params.searchValue" class="input-with-select" size="small">
                                <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                                    <el-option label="话题ID" :value="1"></el-option>
                                    <el-option label="话题名称" :value="2"></el-option>
                                </el-select>
                            </el-input>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                            <el-select v-model="params.type" placeholder="请选择" size="small">
                                <el-option label="不限制话题类型" value=""></el-option>
                                <el-option label="仅看演出话题" :value="1"></el-option>
                                <el-option label="仅看城市话题" :value="2"></el-option>
                                <el-option label="仅看场地话题" :value="3"></el-option>
                                <el-option label="仅看艺人话题" :value="4"></el-option>
                                <el-option label="仅看风格话题" :value="5"></el-option>
                                <el-option label="仅看用户自建话题" :value="6"></el-option>
                                <el-option label="仅看平台自建话题" :value="7"></el-option>
                            </el-select>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                            <el-input v-model="params.createUser" placeholder="请输入创建者ID" size="small"></el-input>
                        </el-col>
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                            <el-select v-model="params.status" placeholder="请选择" size="small">
                                <!-- <el-option label="不限制话题状态" value=""></el-option> -->
                                <el-option label="仅看启用的" :value="1"></el-option>
                                <el-option label="仅看禁用的" :value="0"></el-option>
                            </el-select>
                        </el-col>
                        
                        <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                            <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                            <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                        </el-col>
                    </el-row>
                </div>
                <div class="page-btns-box">
                    <el-button v-if="$utils.have('/topic/save')" type="primary" icon="el-icon-plus" size="small" @click="$refs.editTpl.show()">创建话题</el-button>
                    <el-button v-if="$utils.have('/topic/sort')" type="primary" icon="el-icon-sort" size="small" @click="editSort()">保存排序</el-button>
                </div>
                <div class="page-list-box">
                    <el-table
                        :data="dataList"
                        border
                        style="width: 100%"
                        v-loading="listLoading"
                        size="small"
                        stripe
                    >
                        <el-table-column prop="id" label="话题ID">
                        </el-table-column>
                        <el-table-column prop="name" label="话题名称" show-overflow-tooltip min-width="150">
                        </el-table-column>
                        <el-table-column prop="targetType" label="话题类型">
                            <template slot-scope="scope">
                                {{type.get(scope.row.targetType)}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="contentNum" label="内容数">
                        </el-table-column>
                        <el-table-column prop="accessNum" label="围观人数">
                        </el-table-column>
                        <el-table-column prop="createUser" label="创建者ID">
                        </el-table-column>
                        <el-table-column prop="status" label="状态">
                            <template slot-scope="scope">
                                {{status.get(scope.row.status)}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="sort" label="排列序号" min-width="150">
                            <template slot-scope="scope">
                                <el-input-number v-if="$utils.have('/topic/sort')" v-model="scope.row.sort" :min="0" size="mini" controls-position="right" :precision="0"></el-input-number>
                                <div v-else>{{scope.row.sort}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="150">
                            <template slot-scope="scope">
                                <el-button
                                    v-if="$utils.have('/topic/info')"
                                    type="text"
                                    size="small"
                                    @click="$refs.editTpl.show(scope.row.id)"
                                    >编辑</el-button
                                >
                                <el-button
                                    v-if="$utils.have('/topic/info')"
                                    type="text"
                                    size="small"
                                    @click="editStatus(scope.row)"
                                    >{{scope.row.status == 0 ? '启用' : '禁用'}}</el-button
                                >
                                <el-button
                                    v-if="$utils.have('/topic/recommend')"
                                    type="text"
                                    size="small"
                                    @click="editRecommend(scope.row)"
                                    >{{scope.row.isRecommend == 1 ? '取消推荐' : '推荐'}}</el-button
                                >
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div v-if="data" class="page-pagination-box">
                    <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="getDataList"
                        :current-page.sync="params.pageNo"
                        :page-sizes="$pageSizes"
                        :page-size.sync="params.pageSize"
                        layout="total, sizes, prev, pager, next"
                        :total="data.totalCount || 0">
                    </el-pagination>
                </div>
                <edit ref="editTpl" @onUpdate="getDataList()"></edit>
            </el-tab-pane>
            <el-tab-pane v-if="$utils.have('/topic/topicPermission')" label="话题权限管理">
                <el-form label-position="top">
                    <el-form-item label="是否允许用户自建话题：">
                        <el-radio-group v-model="canCreate" @change="updateTopicPermission">
                            <el-radio :label="1">允许</el-radio>
                            <el-radio :label="0">不允许</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
        </el-tabs>
        
    </div>
</template>

<script>
import Edit from "./components/Edit.vue";
const defaultParams = {
    pageNo:1,
    isRecommend: -1,
    createUser: "",
    searchType: 1,
    searchValue: "",
    sortType: 1,
    status: 1,
    type: ""
}
export default {
    components:{
        Edit
    },
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: 1,
                pageSize: this.$pageSizes[0],
            },
            listLoading: true,

            canCreate: 1 //是否允许自建话题 1：允许 0：不允许
        }
    },
    computed: {
        type(){
            return new Map([
                [1,'演出话题'],[2,'城市话题'],[3,'场地话题'],[4,'艺人话题'],[5,'风格话题'],[6,'用户自建话题'],[7,'平台自建话题']
            ])
        },
        status(){
            return new Map([
                [0,'禁用'],[1,'启用']
            ])
        }
    },
    mounted() {
        this.getDataList();
        this.getTopicPermission();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/topic/list",
                method: "POST",
                data: {
                    ...this.params,
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
                    this.data = null;
					this.dataList = [];
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },

        //编辑状态
        editStatus(obj){
            const _msg = obj.status == 1 ? '确定要禁用吗?' : '确定要启用吗？';
            this.$confirm(_msg, '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/topic/enableDisable',
                    method: 'POST',
                    params: {topicId:obj.id}
                }).then(res => {
                    const { state, msg } = res.data;
                    if( state == 1 ){
                        let timer = setTimeout(() => {
                            this.getDataList();
                            clearTimeout(timer);
                        },500)
                        
                    }else{
                        this.$message.error(msg || '请求失败');
                        this.listLoading = false;
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                    this.listLoading = false;
                }).finally(() => {
                    // this.listLoading = false;
                });
            })
        },
        //编辑推荐状态
        editRecommend(obj){
            const _msg = obj.isRecommend == 1 ? '确定要取消推荐吗?' : '确定要推荐吗？';
            this.$confirm(_msg, '提示', {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: '/topic/recommend',
                    method: 'POST',
                    params: {topicId:obj.id}
                }).then(res => {
                    const { state, msg } = res.data;
                    if( state == 1 ){
                        let timer = setTimeout(() => {
                            this.getDataList();
                            clearTimeout(timer);
                        },500)
                        
                    }else{
                        this.$message.error(msg || '请求失败');
                        this.listLoading = false;
                    }
                }).catch(() => {
                    this.$message.error('请求错误');
                    this.listLoading = false;
                }).finally(() => {
                    // this.listLoading = false;
                });
            })
        },
        //编辑排序
        editSort(){
            this.listLoading = true;
            const _sortData = this.dataList.map( v => {
                return{
                    id: v.id,
                    sort: v.sort
                }
            })
            this.$request({
                url: '/topic/sort',
                method: 'POST',
                data: [
                    ..._sortData
                ]
            }).then(res => {
                const { state, msg } = res.data;
                if( state == 1 ){
                    this.getDataList();
                }else{
                    this.$message.error(msg || '请求失败');
                }
            }).catch(() => {
                this.$message.error('请求错误');
            }).finally(() => {
                this.listLoading = false;
            });
        },

        //话题权限
        getTopicPermission(){
            this.$request({
                url: '/topic/topicPermission',
                method: 'POST',
            }).then(res => {
                const { state, result, msg } = res.data;
                if( state == 1 ){
                    this.canCreate = result;
                }else{
                    this.$message.error(msg || '请求失败');
                }
            }).catch(() => {
                this.$message.error('请求错误');
            })
        },
        // 更新话题权限
        updateTopicPermission(){
            this.$request({
                url: '/topic/updateTopicPermission',
                method: 'POST',
                params: {
                    canCreate: this.canCreate
                }
            }).then(res => {
                const { state, msg } = res.data;
                if( state == 1 ){
                    this.$message.success("设置成功");
                }else{
                    this.$message.error(msg || '请求失败');
                }
            }).catch(() => {
                this.$message.error('请求错误');
            })
        }
    }
}
</script>
<style lang="scss" scoped>

</style>